export class NavigationItem {
	Name: string;
	Icon: string;
	URL: string;
	Link: string = "";
	Admin: boolean = false;

	Children: NavigationItem[];

	constructor(init?: Partial<NavigationItem>) {
		Object.assign(this, init);

		if (init && init.Children) {
			this.Children = init.Children.map(c => new NavigationItem(c));
		} else {
			this.Children = new Array<NavigationItem>();
		}
	}
}



// WEBPACK FOOTER //
// ./src/app/navigation/navigation-item.ts